import React, { useState } from "react";
import { FiX, FiGitBranch } from "react-icons/fi";

const WorkflowSettingsModal = ({ show, handleClose, onSave }) => {
  const [workflowNeeded, setWorkflowNeeded] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ workflowNeeded });
    handleClose();
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content border-0 shadow">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              <FiGitBranch className="me-2" />
              Workflow Configuration
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={handleClose}>
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="alert alert-info">
                <small>
                  Enable or disable workflow functionality for your automation.
                </small>
              </div>

              <div className="mb-4">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="workflowToggle"
                    checked={workflowNeeded}
                    onChange={() => setWorkflowNeeded(!workflowNeeded)}
                    style={{ width: '3em', height: '1.5em' }}
                  />
                  <label className="form-check-label fw-bold ms-2" htmlFor="workflowToggle">
                    {workflowNeeded ? 'Workflow Enabled' : 'Workflow Disabled'}
                  </label>
                </div>
                
                <div className="mt-3 text-muted">
                  <small>
                    {workflowNeeded 
                      ? 'Workflow automation will be activated in your system.' 
                      : 'No workflow automation will be used.'}
                  </small>
                </div>
              </div>
            </div>

            <div className="modal-footer border-top-0">
              <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save Configuration
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WorkflowSettingsModal;